import * as types from '../../../../../../constants/ActionNameConstants';

const INITIAL_STATE = {
  loading: false,
  user: [],
  error: null,
};

const ChnagePasswordReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CHANGE_PASSSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.CHANGE_PASSSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
      };
    case types.CHANGE_PASSSWORD_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default ChnagePasswordReducer;
